/**
 * FeatureFlag: A feature flag configuration
 * @property {boolean} enabled - Whether the feature flag is enabled
 * @property {unknown} value - The value of the feature flag
 */
export interface FeatureFlag {
  enabled: boolean;
  value?: unknown;
}

/**
 * FeatureFlags: A collection of feature flags
 * @property {FeatureFlag} [key: string]: FeatureFlag;
 */
export interface FeatureFlags {
  [key: string]: FeatureFlag;
}

/**
 * DEFAULT_FEATURE_FLAGS: The default feature flags
 * @property {FeatureFlag} [key: string]: FeatureFlag;
 */
export const DEFAULT_FEATURE_FLAGS = {
  'enable-auth-nav': {
    enabled: true,
    value: null,
  },
  'enable-maintenance': {
    enabled: false,
    value: null,
  },
} as const;

/**
 * DefaultFeatureFlags: The default feature flags
 * @property {FeatureFlag} [key: string]: FeatureFlag;
 */
export type DefaultFeatureFlags = typeof DEFAULT_FEATURE_FLAGS;

/**
 * DISABLED_FEATURE_FLAGS: The disabled feature flags
 * @property {FeatureFlag} [key: string]: FeatureFlag;
 */
export const DISABLED_FEATURE_FLAGS = Object.keys(DEFAULT_FEATURE_FLAGS).reduce((acc, key) => {
  acc[key] = { enabled: false, value: null };
  return acc;
}, {} as FeatureFlags);
